"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewsSubscribePopup = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _mobile = require("./mobile");
var _desktop = require("./desktop");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ReviewsSubscribePopup extends React.Component {
  render() {
    if (!this.props.isOpen) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, /*#__PURE__*/React.createElement(_mobile.ReviewsSubscribePopupMobile, this.props)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      tablet: true,
      desktop: true
    }, /*#__PURE__*/React.createElement(_desktop.ReviewsSubscribePopupDesktop, this.props)));
  }
}
exports.ReviewsSubscribePopup = ReviewsSubscribePopup;